/* ============================================
   Lovely Colors — Cart drawer (Ajax mini-cart)
   ============================================ */

(function () {
  'use strict';

  class CartDrawer {
    constructor() {
      this.drawer = document.querySelector('[data-cart-drawer]');
      this.backdrop = document.querySelector('[data-cart-backdrop]');
      this.openers = document.querySelectorAll('[data-cart-open]');
      this.closers = document.querySelectorAll('[data-cart-close]');
      this.body = this.drawer ? this.drawer.querySelector('[data-cart-body]') : null;
      this.countEls = document.querySelectorAll('[data-cart-count]');
      this.subtotalEl = document.querySelector('[data-cart-subtotal]');
      if (!this.drawer) return;
      this.bind();
      this.refresh();
    }

    bind() {
      this.openers.forEach((el) => el.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      }));
      this.closers.forEach((el) => el.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
      }));
      if (this.backdrop) this.backdrop.addEventListener('click', () => this.close());
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.drawer.classList.contains('is-open')) this.close();
      });
      document.addEventListener('cart:updated', () => this.refresh());
    }

    open() {
      this.refresh();
      this.drawer.classList.add('is-open');
      if (this.backdrop) this.backdrop.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
      this.drawer.setAttribute('aria-hidden', 'false');
    }

    close() {
      this.drawer.classList.remove('is-open');
      if (this.backdrop) this.backdrop.classList.remove('is-visible');
      document.body.style.overflow = '';
      this.drawer.setAttribute('aria-hidden', 'true');
    }

    async refresh() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        this.countEls.forEach((el) => {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
        if (this.subtotalEl) {
          this.subtotalEl.textContent = this.formatMoney(cart.total_price);
        }
        if (this.body) {
          if (cart.item_count === 0) {
            this.body.innerHTML = '<p class="cart-drawer__empty">Votre panier est vide.</p>';
          } else {
            this.body.innerHTML = cart.items.map((item) => `
              <article class="cart-line" data-line-key="${item.key}">
                <a href="${item.url}" class="cart-line__img">
                  <img src="${item.image}" alt="${item.product_title}" loading="lazy" width="80" height="80">
                </a>
                <div class="cart-line__info">
                  <a href="${item.url}" class="cart-line__title">${item.product_title}</a>
                  ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-line__variant">${item.variant_title}</p>` : ''}
                  <div class="cart-line__actions">
                    <div class="cart-line__qty">
                      <button type="button" data-qty-minus aria-label="Diminuer">−</button>
                      <input type="number" value="${item.quantity}" min="0" data-qty-input>
                      <button type="button" data-qty-plus aria-label="Augmenter">+</button>
                    </div>
                    <span class="cart-line__price">${this.formatMoney(item.line_price)}</span>
                  </div>
                </div>
                <button type="button" class="cart-line__remove" data-cart-remove aria-label="Retirer">✕</button>
              </article>
            `).join('');
            this.bindLineItems();
          }
        }
      } catch (e) {
        console.error('[Cart] refresh failed', e);
      }
    }

    bindLineItems() {
      if (!this.body) return;
      this.body.querySelectorAll('.cart-line').forEach((line) => {
        const key = line.dataset.lineKey;
        const input = line.querySelector('[data-qty-input]');
        const plus = line.querySelector('[data-qty-plus]');
        const minus = line.querySelector('[data-qty-minus]');
        const remove = line.querySelector('[data-cart-remove]');

        const change = async (qty) => {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
          });
          this.refresh();
        };

        plus?.addEventListener('click', () => change(parseInt(input.value, 10) + 1));
        minus?.addEventListener('click', () => change(parseInt(input.value, 10) - 1));
        input?.addEventListener('change', () => change(parseInt(input.value, 10)));
        remove?.addEventListener('click', () => change(0));
      });
    }

    formatMoney(cents) {
      return (cents / 100).toLocaleString('fr-FR', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'EUR'
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new CartDrawer());
  } else {
    new CartDrawer();
  }

  // Capture all ATC forms globally
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!res.ok) throw new Error('add_failed');
      document.dispatchEvent(new CustomEvent('cart:updated'));
      const drawer = document.querySelector('[data-cart-drawer]');
      if (drawer) {
        const opener = document.querySelector('[data-cart-open]');
        if (opener) opener.click();
      }
    } catch (err) {
      console.error('[Cart] add failed', err);
    } finally {
      if (btn) btn.disabled = false;
    }
  });

  // Quick-add: the "+" buttons on the product grid cards
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.pc-add[data-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const id = btn.getAttribute('data-add');
    if (!id || btn.dataset.loading === '1') return;
    btn.dataset.loading = '1';
    const original = btn.textContent;
    btn.textContent = '…';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      });
      if (!res.ok) throw new Error('add_failed');
      document.dispatchEvent(new CustomEvent('cart:updated'));
      try {
        const cart = await (await fetch('/cart.js')).json();
        document.querySelectorAll('.cart-pill .count, [data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
      } catch (_) {}
      btn.textContent = '✓';
      btn.classList.add('is-added');
      setTimeout(() => { btn.textContent = original; btn.classList.remove('is-added'); btn.dataset.loading = '0'; }, 1500);
    } catch (err) {
      console.error('[Cart] quick-add failed', err);
      btn.textContent = '✕';
      setTimeout(() => { btn.textContent = original; btn.dataset.loading = '0'; }, 1500);
    }
  }, true);
})();
